import { utils } from 'ethers';

export const toBigNumber = (number: number, decimals?: number) => {
  return utils.parseUnits(number.toString(), decimals);
};
